module.exports = __webpack_public_path__ + "img/90.2.TN.dbf31ee9.png";